import { render, staticRenderFns } from "./UserAuthenticationCard.vue?vue&type=template&id=4a9fd6b3"
import script from "./UserAuthenticationCard.vue?vue&type=script&lang=js"
export * from "./UserAuthenticationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports